import { render, staticRenderFns } from "./Curator_outer_editor.vue?vue&type=template&id=7ba8e67c"
import script from "./Curator_outer_editor.vue?vue&type=script&lang=js"
export * from "./Curator_outer_editor.vue?vue&type=script&lang=js"
import style0 from "./Curator_outer_editor.vue?vue&type=style&index=0&id=7ba8e67c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports